module.exports = __webpack_public_path__ + "static/media/DSCF5843.89a312e6.jpg";